export default "__VITE_ASSET__C7SX4cFW__"